import styled from "styled-components";

export const HomePageContainer = styled.main`
  width: 100%;
  height: calc(100vh - 155px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: "Roboto", sans-serif;
`;

export const WelcomeCard = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  max-width: 1000px;
  padding: 48px 40px;
  text-align: center;
  border-radius: 16px;
  background: rgba(256, 256, 256);
  border: 1px solid rgba(0, 0, 0, 0.06);
`;

export const WelcomeLogo = styled.img`
  width: 140px;
  height: auto;
  object-fit: contain;
  margin-bottom: 8px;
`;

export const WelcomeTitle = styled.h1`
  margin: 0;
  font-size: clamp(30px, 2.2vw, 38px);
  font-weight: 500;
  line-height: 1.3;
  text-wrap: balance;
  color: rgba(0, 0, 0, 0.55);
`;

export const WelcomeSubtitle = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  text-wrap: balance;
  color: rgba(0, 0, 0, 0.45);
`;